import React, { useEffect, useState } from "react";

const ListOfCase = ({ setSelectedPage }) => {
  const [tableData, setTableData] = useState([]);
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchCases = async () => {
      try {
        const headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        };

        const response = await fetch("https://admindashboard.clns.in/api/dashboard/cases/get/", {
          method: "GET",
          headers: headers,
        });

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();
        setTableData(data.cases_list);
      } catch (error) {
        console.error("Error fetching cases:", error);
      }
    };

    fetchCases();
  }, [token]);

  console.log(tableData,"tableData")

  const handleSelect = (id) => {
    localStorage.setItem("selectedCaseId", id);
    setSelectedPage("CaseInfoPage");
  };

  return (
    <div style={styles.page}>
      <h3 style={styles.title}>
        List of cases
      </h3>

      <div style={styles.gridContainer}>
        <div style={styles.tableContainer}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.header}>Client Name</th>
                <th style={styles.header}>Lawyer Name</th>
                <th style={styles.header}>C Phoneno.</th>
                <th style={styles.header}>L Phoneno.</th>
                <th style={styles.header}>Case ID</th>
                <th style={styles.header}>Status</th>
                <th style={styles.header}>Created Date</th>
                <th style={styles.header}>Action</th>
              </tr>
            </thead>
            <tbody>
              {tableData?.map((row, index) => (
                <tr key={index} style={styles.row}>
                  <td style={styles.cell}>{row.clients.first_name} {row.clients.last_name}</td>
                  <td style={styles.cell}>{row.advocate.first_name} {row.advocate.last_name}</td>
                  <td style={styles.cell}>{row.clients.client_mobile_num}</td>
                  <td style={styles.cell}>{row.advocate.mobile_num}</td>
                  <td style={styles.cell}>{row.case_id}</td>
                  <td style={styles.cell}>{row.case_status}</td>
                  <td style={styles.cell}>{new Date(row.created_at).toLocaleDateString()}</td>
                  <td style={styles.buttonCell}>
                    <button style={styles.addButton} onClick={() => handleSelect(row.id)}>Select</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const styles = {
  page: {
    display: "grid",
    gap: "20px",
    paddingLeft: "10%",
    height: "50vh",
    backgroundColor: "#f9f9f9",
  },
  title: {
    paddingRight: "20%",
    margin: "10px 10px",
    fontSize: "20px",
    fontWeight: "bold",
    textAlign: "center",
  },
  gridContainer: {
    display: "grid",
    gap: "20px",
    overflow: "hidden",
  },
  tableContainer: {
    maxHeight: "500px",
    overflowY: "auto",
    overflowX: "auto",
    border: "1px solid #ddd",
    borderRadius: "5px",
    backgroundColor: "white",
  },
  table: {
    borderCollapse: "collapse",
    width: "100%",
    minWidth: "1200px",
  },
  header: {
    backgroundColor: "#f4f4f4",
    padding: "10px",
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "bold",
    whiteSpace: "nowrap",
  },
  cell: {
    padding: "10px",
    border: "1px solid #ddd",
    textAlign: "center",
    whiteSpace: "nowrap",
  },
  buttonCell: {
    padding: "5px",
    textAlign: "center",
    border: "1px solid #ddd",
  },
  addButton: {
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    padding: "5px 10px",
    borderRadius: "5px",
    cursor: "pointer",
  },
  row: {
    backgroundColor: "#fff",
  },
};

export default ListOfCase;